import React, { useState } from 'react'
import './styles.scss'
import { ShowMoreButton } from 'components/ShowMoreButton'

export const ElementAccordion = ({
  items,
  additionalItems,
  buttonLabels,
  element
}: {
  items: any[]
  additionalItems: any[]
  element: (a: any, b?: number) => React.ReactChild
  buttonLabels: { open: string; closed: string }
}) => {
  const [open, setOpen] = useState(false)
  return (
    <div className='ElementAccordion'>
      <div className='head'>
        {items.map((m, i) => {
          return element(m, i)
        })}
      </div>
      {open && (
        <div className='tail'>
          {additionalItems.map((m, i) => {
            return element(m, i)
          })}
        </div>
      )}
      <div className='buttoncontainer'>
        <ShowMoreButton labels={buttonLabels} current={open} toggle={setOpen} />
      </div>
    </div>
  )
}
